export default {
  failed_to_open: 'Onboarding kunne ikke åbnes for denne restaurant. Prøv igen.',
};
